import { createAsyncThunk } from '@reduxjs/toolkit';
import { RootState } from '../index';
import { getBroadcastChatRoom, getChatRoomsList, getChatRoomsListBySpecialistId } from '../../api/agora/chatRooms';

export const fetchChatRooms = createAsyncThunk('chatRooms/fetchChatRooms', async (userId: string, thunkAPI) => {
  const {
    chatRooms: { limit, offset },
  } = thunkAPI.getState() as RootState;
  const response = await getChatRoomsList(userId, limit, offset);
  return response.data;
});

export const fetchChatRoomsBySpecialistID = createAsyncThunk(
  'chatRooms/fetchChatRoomsBySpecialistId',
  async ({ clientID, specialistId }: { specialistId: string; clientID: string }) => {
    const response = await getChatRoomsListBySpecialistId(clientID, specialistId);
    return response.data;
  }
);

export const fetchBroadcastChatRoom = createAsyncThunk('chatRooms/fetchBroadcastChatRoom', async (userId: string) => {
  const { data: response } = await getBroadcastChatRoom(userId);
  return response.data;
});
